import React from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button } from 'react-bootstrap';

const REASON_STYLES = {
  action_required: { variant: 'warning', icon: 'ri-alert-line' },
  stuck: { variant: 'dark', icon: 'ri-time-line' },
  declined: { variant: 'danger', icon: 'ri-thumb-down-line' },
  pending_signature: { variant: 'info', icon: 'ri-quill-pen-line' },
};

function reasonStyle(reason) {
  const key = String(reason || '').toLowerCase();
  return REASON_STYLES[key] || { variant: 'secondary', icon: 'ri-flag-line' };
}

const TeamActionItemList = ({ items = [], formatPersonLabel }) => (
  <div className="team-action-list">
    {items.map((item) => {
      const envelopeId = item.envelope_id ?? item.id;
      const title = item.name ?? item.subject ?? `Envelope ${envelopeId}`;
      const reason = reasonStyle(item.reason);
      const reasonLabel = String(item.reason || '').replace(/_/g, ' ') || '—';
      return (
        <div key={`${envelopeId}-${item.reason}`} className="team-action-list__item">
          <div className={`team-action-list__accent bg-${reason.variant}`} />
          <div className={`team-action-list__icon text-${reason.variant}`}>
            <i className={reason.icon} aria-hidden="true" />
          </div>
          <div className="team-action-list__content">
            <div className="team-action-list__title">
              {envelopeId ? (
                <Link to={`/envelopes/${envelopeId}/progress`}>{title}</Link>
              ) : title}
            </div>
            <div className="team-action-list__meta">
              <Badge bg="light" text="dark" className="text-capitalize">{item.status || '—'}</Badge>
              <Badge bg={reason.variant} className="text-capitalize">{reasonLabel}</Badge>
              <span className="text-muted small">{formatPersonLabel(item.created_by_name ?? item.created_by ?? item.created_by_user)}</span>
            </div>
          </div>
          {envelopeId ? (
            <Button
              as={Link}
              to={`/envelopes/${envelopeId}/progress`}
              size="sm"
              variant="outline-primary"
              className="team-action-list__cta"
            >
              View
            </Button>
          ) : null}
        </div>
      );
    })}
  </div>
);

export default TeamActionItemList;
